// extracted by mini-css-extract-plugin
module.exports = {"contextMenuButton":"CreateEntityMenu_contextMenuButton__12CuT","contextMenu":"CreateEntityMenu_contextMenu__14yVv","contextIcon":"CreateEntityMenu_contextIcon__XGXY-"};